
const privateRoutePaths = {
    ADMIN_DASHBOARD: {
        path: "/dashboard",
        permission: ["SUP_ADM", "ADMIN"]
    },
    UPDATE_COMPANY_PROFILE: {
        path: "/updateprofile/:id",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER", "VIEWER", "DEMO", "OPERATION_USER", "INQ_MANAGER", "ADMIN"]
    },
    VIEW_COMPANY_PROFILE: {
        path: "/company/:id",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER", "VIEWER", "DEMO", "OPERATION_USER", "INQ_MANAGER", "ADMIN"]
    },
    VIEW_LOGISTIC_PROFILE: {
        path: "/logistic-company/:id",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER", "VIEWER", "DEMO", "OPERATION_USER", "INQ_MANAGER", "ADMIN"]
    },
    MANAGE_MEMBERS: {
        path: "/members",
        permission: ["SUP_ADM", "END_USER", "VIEWER", "OPERATION_USER", "INQ_MANAGER", "ADMIN"]
    },
    MANAGE_LOGISTIC_MEMBERS: {
        path: "/logistics-members",
        permission: ["SUP_ADM", "END_USER", "VIEWER", "DEMO", "OPERATION_USER", "INQ_MANAGER", "ADMIN"]
    },
    MANAGE_LEADS: {
        path: "/manage-leads",
        permission: ["SUP_ADM", "VIEWER", "OPERATION_USER", "INQ_MANAGER", "ADMIN"]
    },
    MANAGE_USERS: {
        path: "/manage-users",
        permission: ["SUP_ADM", "ADMIN"]
    },
    MANAGE_SHIPMENTS: {
        path: "/manage-shipments",
        permission: ["SUP_ADM", "ADMIN"]
    },
    MANAGE_PLANS: {
        path: "/manage-plans",
        permission: ["SUP_ADM", "ADMIN"]
    },
    MANAGE_PLAN_SETTINGS: {
        path: "/plan-settings",
        permission: ["SUP_ADM"],
    },
    MANAGE_PAID_MEMBERS: {
        path: "/paid-members",
        permission: ["SUP_ADM", "OPERATION_USER", "INQ_MANAGER"]
    },
    MANAGE_PENDING_MEMBERS: {
        path: "/pending-member-requests",
        permission: ["SUP_ADM", "OPERATION_USER"]
    },
    ADMIN_INQUIRIES: {
        path: "/all-inquiries/:fordate?",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER"]
    },
    LOGISTIC_INQUIRIES: {
        path: "/logistic-inquiries/:fordate?",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER", "ADMIN"]
    },
    ADD_LOGISTIC_INQUIRY: {
        path: "/add-logistic-inquiry",
        permission: ["SUP_ADM", "INQ_MANAGER"]
    },
    VIEW_LOGISTIC_INQUIRY: {
        path: "/view-logistic-inquiry/:id",
        permission: ["SUP_ADM","INQ_MANAGER","ADMIN"]
    },
    SUPPLIER_INQUIRIES: {
        path: "/supplier-inquiries",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER"]
    },
    MANAGE_COUNTRIES: {
        path: "/manage-countries",
        permission: ["SUP_ADM"]
    },
    MANAGE_CITIES: {
        path: "/manage-cities/:city_status",
        permission: ["SUP_ADM"]
    },
    MANAGE_INDUSTRIES: {
        path: "/manage-industries/:industry_status",
        permission: ["SUP_ADM"]
    },
    MANAGE_SERVICES: {
        path: "/manage-services/:service_status",
        permission: ["SUP_ADM"]
    },
    MANAGE_HSCODE: {
        path: "/manage-hs-codes/:hs_code_status",
        permission: ["SUP_ADM"]
    },
    MANAGE_CERTIFICATES: {
        path: "/manage-certificates",
        permission: ["SUP_ADM"]
    },
    MANAGE_PORTS: {
        path: "/manage-ports/:port_status",
        permission: ["SUP_ADM"]
    },
    MANAGE_ROLES: {
        path: "/manage-roles",
        permission: ["SUP_ADM"]
    },
    SHIPMENT_COMPANY_LIST: {
        path: "/buyer-supplier",
        permission: ["SUP_ADM", "DEMO"]
    },
    SHIPMENT_TRADE_DETAIL: {
        path: "/trade-detail/:type/:company_name",
        permission: ["SUP_ADM", "DEMO"]
    },
    PRE_KYC_DASHBOARD: {
        path: "/landing-dashboard",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER", "VIEWER", "DEMO", "OPERATION_USER", "INQ_MANAGER"]
    },
    MY_INQUIRIES: {
        path: "/my-inquiries",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER", "VIEWER"]
    },
    MEMBERS_FORM: {
        path: "/member-form",
        permission: ["SUP_ADM", "VIEWER"]
    },
    USER_SETTINGS: {
        path: "/user-settings",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER"]
    },
    CHANGE_PSWD: {
        path: "/change-password",
        permission: ["SUP_ADM", "PRE_KYC", "END_USER"]
    },
    PROFILE_HISTORY: {
        path: "/profile-history/:id",
        permission: ["SUP_ADM", "VIEWER", "ADMIN"]
    },
    MOCK_INQUIRIES: {
        path: "/mock-inquiries",
        permission: ["SUP_ADM", "INQ_MANAGER", "ADMIN"]
    },
    MOCK_INQUIRY_VIEW: {
        path: "/mock-inquiry-view/:id",
        permission: ["SUP_ADM", "INQ_MANAGER"]
    },
    OTP_LIST: {
        path: "/otp-list",
        permission: ["SUP_ADM", "ADMIN"]
    },
    MY_PRODUCTS: {
        path: "/my-products",
        permission: ["SUP_ADM", "VIEWER", "END_USER", "PRE_KYC", "OPERATION_USER", "ADMIN"]
    },
    MY_PRODUCTS_ADD: {
        path: "/my-products/add",
        permission: ["SUP_ADM", "VIEWER", "END_USER", "PRE_KYC", "OPERATION_USER"]
    },
    UPDATE_PRODUCT: {
        path: "/updateproduct/:id",
        permission: ["SUP_ADM", "VIEWER", "END_USER", "PRE_KYC", "OPERATION_USER"]
    },
    REQUEST_UPDATE_PRODUCT: {
        path: "/req-update-product/:id",
        permission: ["SUP_ADM", "VIEWER", "END_USER", "PRE_KYC", "OPERATION_USER"]
    },
    PRODUCT_REQUEST: {
        path: "/product-requests",
        permission: ["SUP_ADM", "OPERATION_USER"]
    },
    VIEW_SUPPLIERS: {
        path: "/all-suppliers/:id",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER","ADMIN"]
    },
    ADMIN_CHOOSE_PLAN:{
        path: "/membership-plans/:id",
        permission:["PRE_KYC","END_USER"]
    },
    PAYMENT_SUCCESS:{
        path:"/payment-success",
        permission: []
    },
    SUPPLIER_INQUIRY_REPORT:{
        path: "/supplier-inquiry-report/:id",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER", "ADMIN"]
    },
    SUPPLIER_INQUIRY_REPORT_DETAIL:{
        path: "/inquiry-report-detail/:id",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER", "ADMIN"]
    },
    RAW_DATA: {
        path: "/inquiry-raw-data",
        permission: ["SUP_ADM", "DEMO", "VIEWER", "INQ_MANAGER", "ADMIN"]
    }

    // Not in used currently 2025-09-02
    /*ADD_SHIPMENT: {
        path: "/shipment/add",
        element: <AddShipment />
    }, */


};


export {
    privateRoutePaths
};
